// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c15cdcb2","134":"270cac89","147":"b28b7003","152":"146ca88d","198":"5c830e18","362":"6e4a8f40","404":"3ac5f455","480":"e442d28f","541":"a9570dbc","579":"d51294ca","747":"f0ccc480","854":"69aa74ee"}[chunkId] + ".chunk.js";
};